

































































import { Component, Mixins } from 'vue-property-decorator';
import DetailMixin from '@/mixins/DetailMixin';
import FieldDefs from './FieldDefs';
import { IDRec } from '@/interfaces';

@Component
export default class DeviceTestDetail extends Mixins(DetailMixin) {
  public tableCfg = FieldDefs;
  public url = this.getTableCfg(this.tableCfg, 'url');
  public apiUrl = this.getTableCfg(this.tableCfg, 'apiUrl');
  public items: IDRec[] = [];

  public headers = [
    {
      text: 'Naam',
      value: 'name'
    },
    {
      text: 'Type',
      value: 'linedatatype'
    },
    {
      text: 'Standaard',
      value: 'default'
    },
    {
      text: 'Titel NL',
      value: 'title_nl'
    },
    {
      text: 'Titel FR',
      value: 'title_fr'
    },
    {
      text: 'Items NL Count',
      value: 'values_cnt_nl'
    },
    {
      text: 'Items FR Count',
      value: 'values_cnt_fr'
    }
  ];

  public get isNew() {
    return this.$route.params.id === 'new';
  }

  public goToNewDeviceTestLine() {
    const deviceTestId = this.$route.params.id;
    this.$router.push('/devices/tests/' + deviceTestId + '/lines/new');
  }

  public get getDeviceTestLineLink() {
    const deviceTestId = this.$route.params.id;
    return '/devices/tests/' + deviceTestId + '/lines/';
  }

  public async getDeviceTestLines() {
    const id = this.$route.params.id;
    const response = await this.api.getLines(this.$store, '/devicetests/' + id);
    if (response) {
      const items = response.data.data;
      this.items = items;
    }
  }

  public async DeviceTestLinesChange(moved) {
    const id = this.$route.params.id;
    const order: number[] = [];
    for (const item of this.items) {
      order.push(item.id);
    }
    const response = await this.api.createRecord(
      this.$store,
      '/devicetests/' + id + '/lines/set_order',
      {
        idlist: order
      }
    );
  }

  public async DeviceTestLinesDelete(deletedId) {
    const id = this.$route.params.id;
    const response = await this.api.deleteRecord(
      this.$store,
      '/devicetests/' + id + '/lines/' + String(deletedId)
    );
  }

  // Lifecycle Functions
  public created() {
    if (!this.isNew) {
      this.getDeviceTestLines();
    }
  }
}
